import { startGoogleSignIn } from "../lib/googleAuth";

const GoogleLogo = () => (
  <svg viewBox="0 0 48 48" className="w-4 h-4" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export const GoogleSignInButton = ({ testId, label = "Continue with Google" }) => (
  <>
    <div className="flex items-center gap-3 my-5" aria-hidden="true">
      <span className="h-px flex-1 bg-white/15" />
      <span className="font-mono-cosmic text-[9px] tracking-[0.35em] text-white/40 uppercase">or</span>
      <span className="h-px flex-1 bg-white/15" />
    </div>
    <button
      type="button"
      onClick={startGoogleSignIn}
      className="w-full inline-flex items-center justify-center gap-3 py-3 border border-white/25 bg-white/[0.04] text-white hover:border-white/60 hover:bg-white/10 font-mono-cosmic text-[11px] tracking-[0.25em] uppercase transition-colors"
      data-testid={testId}
    >
      <GoogleLogo /> {label}
    </button>
  </>
);
